module.exports = __webpack_public_path__ + "static/media/image_35.c5d87d8b.png";